module.exports = __webpack_public_path__ + "media/images/logo/niet_gebruikt/logo2-279c676787b84cf7c89ee57a4fb611a9.png";